var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.selectedGroup)?_c('Overview',{attrs:{"groups":_vm.groups},on:{"groupSelected":_vm.groupSelected}}):_c('Group',{attrs:{"groupId":_vm.selectedGroup.id},on:{"close":_vm.closeGroup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }